/** @format */

import React, {useContext} from 'react';

import {
    GRAPHIC_DESIGN_ORDER_TYPE_ARTWORK_EDITS,
    GRAPHIC_DESIGN_ORDER_TYPE_ARTWORK_RECREATION,
    GRAPHIC_DESIGN_ORDER_TYPE_CUSTOM_DESIGN,
    PRODUCT_TYPE_CARTON,
    PRODUCT_TYPE_LABEL
} from 'frontier-constants';

import GoBack from './go_back';
import {capitalize} from 'frontier/ds/quoter/functions/format';
import {QuoteContext} from 'frontier-quoter';

export default function DesignTypeHeading({designType, productType, onClickBack}) {
    const ctx = useContext(QuoteContext);
    let link;
    switch (productType) {
        case PRODUCT_TYPE_LABEL:
            link = <a href={`/orders/custom-labels`}>label</a>;
            break;
        case PRODUCT_TYPE_CARTON:
            link = <a href={`/orders/custom-cartons`}>carton</a>;
            break;
    }

    switch (designType) {
        case GRAPHIC_DESIGN_ORDER_TYPE_ARTWORK_EDITS:
            return (
                <>
                    <GoBack label="Back to Design Quote" onClick={onClickBack} />
                    <h1 className="mt-0">Artwork Edits</h1>
                    <p>
                        If you only need help with changing colors in 5 or fewer files OR need us to
                        simply change one word in your file(s), please proceed with your full {link}{' '}
                        order and let us know about the changes in the Artwork Instructions box.
                        Otherwise, please fill out the form below.
                    </p>
                </>
            );
        case GRAPHIC_DESIGN_ORDER_TYPE_ARTWORK_RECREATION:
            return (
                <>
                    <GoBack label="Back to Design Quote" onClick={onClickBack} />
                    <h1 className="mt-0">Artwork Recreation</h1>
                    <p>
                        We will recreate your low-resolution design files or an image of your{' '}
                        {ctx.singularProduct} design to meet our printing standards. Fill out the
                        information below to get started!
                    </p>
                </>
            );
        case GRAPHIC_DESIGN_ORDER_TYPE_CUSTOM_DESIGN:
            return (
                <>
                    <GoBack label="Back to Design Quote" onClick={onClickBack} />
                    <h1 className="mt-0">Custom Artwork</h1>
                </>
            );
    }
}
